/**
 * Silhouette of the Convo brand mark, on a 32x32 viewBox.
 *
 * Two places draw it: {@link ConvoIcon}, and the greyed, cracked variant on the
 * global error page. Those renderings differ on purpose - global-error replaces
 * the root layout, so it cannot rely on the app's stylesheet and inlines its own
 * colours - but the shape itself is one thing, and lives here. This module holds
 * no imports, so the error page stays as dependency-light as it should be.
 */
export const CONVO_MARK_PATH =
  "M13 0h6a13 13 0 0 1 13 13v6a13 13 0 0 1-13 13H5a5 5 0 0 1-5-5V13A13 13 0 0 1 13 0Z";
